// Copyright (c) 2017 Deere & Company

import SearchByDropDown from '@deere/cps-it.warranty-model-factory/lib/search-by-dropdown';

export const getDefaultState = () =>
    new SearchByDropDown({
        searchBy: [],
        selectedOption: {
            key: 'PRODUCTS',
            value: 'PRODUCTS'
        }
    });

export default SearchByDropDown;



// WEBPACK FOOTER //
// ./src/home-page/state/search-by-dropdown.js